import { formatCurrencyValue } from "../../../util/PaymentUtils";
import { formatFrequency } from "@securspace/securspace-ui-kit";
import { assetTypeOptions, frequencyOptions, BookingStatusGroups } from "../data";
import { formatEndDateDisplay } from "../../../util/DateUtils";

import moment from "moment";

const sortByFields = [
  {label: "Booking Number", value: "ORDER_NUMBER"},
  {label: "Buyer", value: "BUYER_COMPANY_NAME"},
  {label: "Start Date", value: "START_DATE"}
];

const filterBySelectOption = [
  {
    label: "Equipment Type",
    value: "",
    name: "equipmentType",
    option: assetTypeOptions
  },
  {
    label: "Frequency",
    value: "",
    name: "frequency",
    option: frequencyOptions
  }
];

const supplierHeaderCells = [
  { id: 'orderNumber', label: 'BOOKING NUMBER' },
  { id: 'buyerCompanyName', label: 'Buyer' },
  { id: 'startDateValue', label: 'Start Date' },
  { id: 'endDateValue', label: 'End Date' },
  { id: 'numberOfSpaces', label: 'Number of Spaces' },
  { id: 'locationName', label: 'Location' },
  { id: 'brokered', label: 'Brokered' },
  { id: 'frequencyValue', label: 'Frequency' },
  { id: 'assetType', label: 'Equipment Type' },
  { id: 'netRate', label: 'Net Booking Rate' },
  { id: 'status', label: 'STATUS' },
  { id: 'creationDate', label: 'Created On' },
];

function transformBooking(booking) {
  const commonProperties = {
    initialSupplierPayoutAmount: formatCurrencyValue(booking.initialCharge, true),
    recurringSupplierPayoutAmount: formatCurrencyValue(booking.recurringSupplierPayoutAmount, true),
    frequencyValue: formatFrequency(booking.frequency, booking.durationType),
    startDateValue: moment(booking.startDate).format("L h:mm a").toUpperCase(),
    supplierCompanyName: booking.supplierCompanyName ? booking.supplierCompanyName : 'N/A',
    active: booking.active ? 'Active' : 'Not Active',
    brokered: booking.brokered ? 'True' : 'False',
    endDateValue: formatEndDateDisplay(booking?.endDate, "L h:mm A"),
    rate: booking.brokered ? 'N/A' : formatCurrencyValue(booking.rate) + (booking.durationType === 'WEEKLY' ? ' /week' : booking.durationType === 'MONTHLY' ? ' /month' : ' /day'),
    netRate: formatCurrencyValue(booking.netRate) + (booking.durationType === 'WEEKLY' ? ' /week' : booking.durationType === 'MONTHLY' ? ' /month' : ' /day'),
  };

  return {
    ...booking,
    ...commonProperties
  };
}

const SupplierBookingTabs = Object.freeze({
  ACTIVE: BookingStatusGroups.ACTIVE,
  PENDING: BookingStatusGroups.PENDING,
  INACTIVE: BookingStatusGroups.INACTIVE,
  FAILED: BookingStatusGroups.FAILED,
});

export {
    sortByFields,
    supplierHeaderCells,
    filterBySelectOption,
    transformBooking,
    SupplierBookingTabs
}
